/*global define:false*/
define('plugins/textarea/view.js',['pluginBaseView'],
    function (PluginBaseView) {
        'use strict';

        return PluginBaseView.extend({

        });

    });

